

export class BadFileModelRequest { 
   
    WorkflowID?: number;
   
    FileData?: string;
}



// WEBPACK FOOTER //
// ./src/app/model/badFileModelRequest.ts